import React, { useState } from "react"
import { useSelector, useDispatch } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { createBolsa } from '../actions'
import { getRedirect } from '../reducers'
import {
    Box,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Button,
    CircularProgress,
    useColorModeValue,
    Card
} from '@chakra-ui/react'
import { Formik } from 'formik'
import { FormValidator } from '../utils/validationForms'
import Layout from '../layout'
import Editor from "../components/Editor"
import "../styles.css"


const BolsaCreate = () => {

    const[html, setHTML] = useState("")
    const [editor, setEditor] = useState(null);
    const dispatch = useDispatch()
    const redirect = useSelector(state => getRedirect(state))
    const color = useColorModeValue('white', 'gray.800')

    if (redirect) {
        return <Redirect to="/bolsa" />
    }

    return (
        <Layout>
            {redirect && <Redirect to="/bolsa" />}
            <Box w={'full'} bg={color} rounded={'md'} m={3} p={6} >
                <Formik
                    initialValues={{
                        title: '',
                    }}
                    validate={values => FormValidator([
                        { field: 'Titulo', value: values.title, rules: ['required'] },
                    ])}
                    onSubmit={(values, { setSubmitting, resetForm }) => {

                        setSubmitting(true)
                        const formData = new FormData()
                        for (let value in values) {
                            formData.append(value, values[value])
                        }
                        formData.append('description', html)
                        Promise.resolve(dispatch(createBolsa(formData)))
                            .then(() => {
                                setSubmitting(false)
                                resetForm()
                            })

                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                        <form onSubmit={handleSubmit}>

                            <FormControl isInvalid={errors.title && touched.title}>
                                <FormLabel>Titulo</FormLabel>
                                <Input name="title" onChange={handleChange} onBlur={handleBlur} value={values.title} />
                                <FormErrorMessage>{errors.title}</FormErrorMessage>
                            </FormControl>

                            
                            <FormLabel>Contenido</FormLabel>
                            <Card>
                                <Editor placeholder={"Contenido"} setHTML={setHTML} setEditor={setEditor} />
                            </Card>
                            <br />
                            <Button colorScheme="teal" variant="outline" type="submit" mt={4} disabled={isSubmitting}>
                                {isSubmitting ? <CircularProgress /> : 'Guardar'}
                            </Button>
                        </form>
                    )}
                </Formik>
            </Box>
        </Layout>
    )
}

export default BolsaCreate
